import React from 'react';
import {ThemeProvider as MuiThemeProvider, createMuiTheme} from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FF7417',
      contrastText: '#FFF'
    }
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif'
  },
});

export default function ThemeProvider({children}) {
  return (
    <MuiThemeProvider theme={theme}>
      {children}
    </MuiThemeProvider>
  )
}